import { useEffect } from 'react';

function useActivityDetector(onActivity, options = {}) {
  useEffect(() => {
    const handleActivity = (event) => {
      onActivity(event);
    };

    const eventOptions = {
      capture: options.capture || false, // Por defecto false para mantener compatibilidad
    };

    // Agregar listeners para clicks y tecleos
    window.addEventListener('click', handleActivity, eventOptions);
    window.addEventListener('keydown', handleActivity, eventOptions);

    // Cleanup: remover listeners cuando el componente se desmonte
    return () => {
      window.removeEventListener('click', handleActivity, eventOptions);
      window.removeEventListener('keydown', handleActivity, eventOptions);
    };
  }, [onActivity, options.capture]);
}

export default useActivityDetector;